module.exports = __webpack_public_path__ + "img/EITLS.ef9cea48.svg";